import { Avatar, SxProps, Theme } from '@mui/material';
import * as React from 'react';

interface Props {
  firstName?: string;
  lastName?: string;
  mail?: string;
  size?: number;
  sx?: SxProps<Theme>;
}

export const LetterAvatar: React.FC<Props> = ({ firstName, lastName, mail, size = 50, sx }) => {
  const initials = (firstName && lastName ? `${firstName?.[0]}${lastName?.[0]}` : mail?.[0])?.toUpperCase();
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        fontSize: size / 2,
        color: 'text.primary',
        backgroundColor: 'secondary.main',
        ...sx,
      }}
    >
      {initials}
    </Avatar>
  );
};
